module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "analytics-chart"
  }, [(_vm.type === 'area') ? _c('analytics-area-chart', {
    style: (_vm.chartStyle),
    attrs: {
      "chart-data": _vm.getChartData,
      "options": _vm.getChartOptions
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'bar') ? _c('analytics-bar-chart', {
    style: (_vm.chartStyle),
    attrs: {
      "chart-data": _vm.getChartData,
      "options": _vm.getChartOptions
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'doughnut') ? _c('analytics-doughnut-chart', {
    style: (_vm.chartStyle),
    attrs: {
      "chart-data": _vm.getChartData,
      "options": _vm.getChartOptions
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'pie') ? _c('analytics-pie-chart', {
    style: (_vm.chartStyle),
    attrs: {
      "chart-data": _vm.getChartData,
      "options": _vm.getChartOptions
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'polar-area') ? _c('analytics-polar-area-chart', {
    style: (_vm.chartStyle),
    attrs: {
      "chart-data": _vm.getChartData,
      "options": _vm.getChartOptions
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39bdd897","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/analytics/charts/AnalyticsChart.vue
// module id = 3227
// module chunks = 3